import { createRouter, createWebHistory } from 'vue-router'
import { routes, adminRoutes, appfrontRoutes } from '@/router/config'

const rs = routes.concat(adminRoutes).concat(appfrontRoutes)

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: rs
})

export default router
